<template>
  <div class="second-step">
    <!-- <div class="second-step__filter">
            <select name="order_id" id="order_id">
                <option value="1">Calificación</option>
                <option value="2">Menor precio</option>
                <option value="3">Mayor precio</option>
            </select>
        </div> -->
    <div class="second-step__filters">
      <div class="filter">
        <div class="filter__title">Marca</div>
        <custom-select-2
          v-model="brandFilter"
          :options="brands"
        ></custom-select-2>
      </div>
      <div class="filter">
        <div class="filter__title">Distrito</div>
        <custom-select-2
          v-model="districtFilter"
          :options="districts"
        ></custom-select-2>
      </div>
      <div class="filter">
        <div class="filter__title">Valoración</div>
        <custom-select-2
          v-model="ratingFilter"
          :options="ratings"
          :allowClear="false"
        ></custom-select-2>
      </div>
      <div class="filter">
        <div class="filter__title">Especialidad</div>
        <custom-select-2
          v-model="specialtyFilter"
          :options="specialties"
        ></custom-select-2>
      </div>
      <div class="filter">
        <div class="filter__title">Categoría</div>
        <custom-select-2
          v-model="categoryFilter"
          :options="categories"
          :allowClear="false"
        ></custom-select-2>
      </div>
    </div>
    <div class="second-step__grid-container" v-if="filteredGarages.length > 0">
      <div class="second-step__grid">
        <div
          class="second-step__element"
          v-for="garage in filteredGarages"
          :key="garage.id"
        >
          <input
            type="radio"
            name="garage_id"
            :id="'garage_' + garage.id"
            v-model="order.garage_id"
            :value="garage.id"
          />
          <label :for="'garage_' + garage.id">
            <div class="element__portrait">
              <img :src="garage.portrait_image" alt="" />
            </div>
            <div class="element__content">
              <div class="element__logo">
                <img :src="garage.url_image" alt="" />
              </div>
              <div class="element__info">
                <div class="element__name">{{ garage.name }}</div>
                <div class="element__meta">
                  {{ getCategory(garage.category) }}
                </div>
                <div class="element__meta">
                  {{ garage.district_name }}
                </div>
                <div class="element__score">
                  <span>
                    <template v-if="garage.rating">
                      {{ garage.rating }}
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="47.94px"
                        height="45.85px"
                        viewBox="0 0 47.94 45.85"
                        style="enable-background: new 0 0 47.94 45.85"
                        xml:space="preserve"
                      >
                        <path
                          class="st0"
                          d="M26.28,1.44l5.41,10.96c0.38,0.76,1.1,1.29,1.94,1.41l12.09,1.76c2.12,0.31,2.96,2.91,1.43,4.4l-8.75,8.53 c-0.61,0.59-0.89,1.45-0.74,2.28l2.06,12.04c0.36,2.11-1.85,3.72-3.75,2.72l-10.81-5.69c-0.75-0.4-1.65-0.4-2.4,0l-10.81,5.69 c-1.89,1-4.11-0.61-3.75-2.72l2.06-12.04c0.14-0.84-0.13-1.69-0.74-2.28l-8.75-8.53c-1.53-1.49-0.69-4.1,1.43-4.4l12.09-1.76 c0.84-0.12,1.57-0.65,1.94-1.41l5.41-10.96C22.6-0.48,25.34-0.48,26.28,1.44z"
                        />
                      </svg>
                    </template>
                  </span>
                  <button
                    class="btn btn--blue"
                    @click.prevent="getPopup(garage.id)"
                  >
                    Ver taller
                  </button>
                </div>
              </div>
              <div class="element__price"></div>
            </div>
          </label>
        </div>
        <div
          v-if="filteredGarages.length === 0"
          class="second-step__not-elements"
        >
          No se encontraron resultados para tu búsqueda.
        </div>
      </div>
    </div>
    <div class="next-step" v-if="!frontpage && filteredGarages.length > 0">
      <a href="#" class="btn btn--blue" @click.prevent="nextStep()"
        >Siguiente</a
      >
    </div>
  </div>

  <first-step-services-modal
    :url_validate_user="url_validate_user"
    :data="popup"
    :urls="urls"
    @close-modal="closeModal()"
  ></first-step-services-modal>

  <profile-vehicle-modal
    :brands="brands"
    :url_store="url_vehicle_store"
    :url_vehicle_store="url_vehicle_store"
    :url_get_vehicle_models="url_get_vehicle_models"
    :url_get_vehicle_versions="url_get_vehicle_versions"
    @refresh-table="getUserVehicles"
  ></profile-vehicle-modal>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2/dist/sweetalert2'
import { computed, inject, onMounted, ref, watchEffect } from 'vue'
import Categories from '../../../general/js/utils/categories'
import { customAlert } from '../../../general/js/utils/swalMessages'

export default {
  props: {
    brands: {
      type: Array,
      default: () => [],
    },
    districts: {
      type: Array,
      default: () => [],
    },
    specialties: {
      type: Array,
      default: () => [],
    },
    url_get_popup: {
      type: String,
      default: '',
    },
    url_validate_user: {
      type: String,
      default: '',
    },
    url_register: {
      type: String,
      default: '',
    },
    url_get_vehicle_models: {
      type: String,
      default: '',
    },
    url_get_vehicle_versions: {
      type: String,
      default: '',
    },
    url_vehicle_store: {
      type: String,
      default: '',
    },
    url_get_user_vehicles: {
      type: String,
      default: '',
    },
    urls: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const brandFilter = ref('')
    const categoryFilter = ref('1')
    const districtFilter = ref('')
    const ratingFilter = ref('1')
    const specialtyFilter = ref('')
    const flag = inject('flag')
    const frontpage = inject('frontpage')
    const loading = inject('loading')
    const garages = inject('garages')
    const order = inject('order')
    const userId = inject('user_id')
    const popup = ref({})
    const vehicles = inject('vehicles')
    const profileVehicleModal = ref(null)
    const ratings = [
      { id: 1, text: 'De mayor a menor' },
      { id: 2, text: 'De menor a mayor' },
    ]
    const categories = [
      { id: 1, text: 'De mayor a menor' },
      { id: 2, text: 'De menor a mayor' },
    ]

    const openModal = () => {
      $('#garageModal').modal('show')
    }

    const closeModal = () => {
      popup.value = {}
    }

    const getPopup = async (garageId) => {
      loading.value = true

      if (userId === '' || userId === null || userId === undefined) {
        Swal.fire({
          icon: 'warning',
          title: '¡Ups!',
          text: 'Debe iniciar sesión o registrarse para ver los detalles del taller.',
          showCancelButton: false,
          confirmButtonText: '¡Ok!',
        }).then((result) => {
          window.location.href = props.url_register
        })

        loading.value = false
        return false
      }

      try {
        const { data } = await axios.request({
          url: props.url_get_popup,
          method: 'POST',
          data: {
            garage_id: garageId,
          },
        })

        fbq(
          'track',
          data.fb_pixel_data.event_name,
          {},
          {
            eventID: data.fb_pixel_data.event_id,
          }
        )

        popup.value = data
        order.garage_specialties = data.garage_specialties

        openModal()
      } catch (error) {
        console.error(error)
      }

      loading.value = false
    }

    const getUserVehicles = async () => {
      loading.value = true

      try {
        const { data } = await axios.request({
          url: props.url_get_user_vehicles,
          method: 'POST',
        })

        data.map((element) => {
          element.model_name = element.vehicle_model_name
          element.version_name = element.vehicle_version_name

          delete element.vehicle_model_name
          delete element.vehicle_version_name

          return element
        })

        vehicles.value = data
        order.vehicle_id = data[0].id

        flag.value = 2
      } catch (error) {
        console.error(error)
      }

      loading.value = false
    }

    const getSpecialties = async () => {
      loading.value = true

      try {
        const { data } = await axios.request({
          url: props.urls.getSpecialties,
          method: 'GET',
          params: {
            garage_id: order.garage_id,
          },
        })

        order.garage_specialties = data
      } catch (error) {
        console.error(error)
      }

      loading.value = false
    }

    const filteredGarages = computed(() =>
      garages
        .filter((element) =>
          brandFilter.value
            ? element.brands.find((e) => e.id === parseInt(brandFilter.value))
            : element
        )
        .filter((element) =>
          districtFilter.value
            ? element.district_id === parseInt(districtFilter.value)
            : element
        )
        .filter((element) =>
          specialtyFilter.value
            ? element.specialties.find(
                (e) => e.id === parseInt(specialtyFilter.value)
              )
            : element
        )
        .sort((a, b) => {
          if (+a.rating > +b.rating)
            return parseInt(ratingFilter.value) === 1 ? -1 : 1
          if (+a.rating < +b.rating)
            return parseInt(ratingFilter.value) === 1 ? 1 : -1
          if (+a.category > +b.category)
            return parseInt(categoryFilter.value) === 1 ? -1 : 1
          if (+a.category < +b.category)
            return parseInt(categoryFilter.value) === 1 ? 1 : -1

          return 0
        })
    )

    const getCategory = (id) => {
      return Categories(id)
    }

    const nextStep = () => {
      if (order.garage_id === '') {
        const data = {
          type: 2,
          title: '¡Ups!',
          subtitle: 'Debe seleccionar un taller',
        }

        customAlert(data)

        return false
      }

      if (userId === '' || userId === null || userId === undefined) {
        Swal.fire({
          icon: 'warning',
          title: '¡Ups!',
          text: 'Debe iniciar sesión o registrarse para continuar',
          showCancelButton: false,
          confirmButtonText: '¡Ok!',
        }).then((result) => {
          window.location.href = props.url_register
        })

        return false
      }

      if (vehicles.value.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: '¡Ups!',
          text: 'Debe registrar un vehículo para continuar',
          showCancelButton: false,
          confirmButtonText: '¡Ok!',
        }).then((result) => {
          $('#addVehicleModal').modal('show')
        })

        return false
      }

      flag.value = 2
    }

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search)
      specialtyFilter.value = urlParams.get('specialtyFilter') || ''
    })

    watchEffect(async () => {
      const garage = garages.find((element) => element.id === order.garage_id)

      if (garage) {
        order.garage_name = garage.name
        await getSpecialties()
      }
    })

    return {
      brandFilter,
      categories,
      categoryFilter,
      districtFilter,
      filteredGarages,
      frontpage,
      garages,
      order,
      popup,
      ratingFilter,
      ratings,
      specialtyFilter,
      profileVehicleModal,
      closeModal,
      getPopup,
      nextStep,
      openModal,
      getCategory,
      getUserVehicles,
      getSpecialties,
    }
  },
}
</script>
<style>
.second-step__grid {
  height: 640px;
  overflow: auto;
}
</style>
